import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const ControlConnectedIcon = ({ width = 30, height = 30 }: { width?: number; height?: number }) => {
  const { token } = useToken();
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd">
        <g>
          <g transform="translate(-170 -68) translate(164.483 62.483)">
            <circle cx="25.517" cy="25.517" r="10.345" fill={token.colorPrimary} />
            <path
              fill={token.colorBgContainer}
              d="M25.517 13.793c6.475 0 11.724 5.25 11.724 11.724 0 6.475-5.249 11.724-11.724 11.724-6.475 0-11.724-5.249-11.724-11.724 0-6.475 5.25-11.724 11.724-11.724zM35.84 26.207h-5.543c-.335 2.34-2.347 4.138-4.779 4.138s-4.444-1.798-4.778-4.138h-5.544c.355 5.392 4.84 9.655 10.322 9.655 5.482 0 9.968-4.263 10.322-9.655zm-11.012-4.069c-1.574.32-2.758 1.711-2.758 3.38 0 1.667 1.184 3.059 2.758 3.378v-6.758zm1.38 0v6.758c1.574-.32 2.759-1.71 2.759-3.379 0-1.668-1.185-3.06-2.759-3.379zm-.69-6.966c-5.481 0-9.967 4.264-10.322 9.655h5.544c.334-2.34 2.346-4.137 4.778-4.137 2.432 0 4.444 1.798 4.779 4.137h5.543c-.354-5.391-4.84-9.655-10.322-9.655z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ControlConnectedIcon;
